function ChangePath( path, value, err ) {
  if ( err ) {
    console.log( `error setting ${path} to ${value}` );
    return;
  }
  this.props.onChange( { target : this.props.interpolator, path, value } );
}

module.exports = {
  ChangePath
}
